<template>
  <a-modal
    title="添加发票信息"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              发票信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['invoice_name', {initialValue: model['invoice_name'], rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票代码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['invoice_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票号码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['invoice_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" v-decorator="['invoice_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['invoice_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width: 100%"
                v-decorator="['invoice_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="发票日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl"></component>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'
import DetailCreateForm from './CreateForm'
import AttachmentCreateForm from '../../detail/attachment/modules/CreateForm'
import { project_client_list } from '@/api/trade_project_client'
import {
  booking_contract_list,
  charter_party_contract_list,
  freight_forwarding_contract_list,
  inspection_contract_list,
  insurance_contract_list,
  loading_supervision_contract_list,
  storage_contract_list, supervision_contract_list
} from '@/api/trade_contract'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { contract_list } from '@/api/contract'
import { corporation_list } from '@/api/trade_corporation'

// 表单字段
const fields = ['invoice_name']
export default {
  components: {
    AttachmentCreateForm,
    DetailCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.invoiceIssuerCorporationSearch = debounce(this.handleInvoiceIssuerCorporationSearch, 800)
    this.recipientCorporationSearch = debounce(this.handleRecipientCorporationSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      projectList: [],
      clientList: [],
      method: this.$Dictionaries.trade_fapiao_method,
      contractList: [],
      sellContractList: [],
      invoiceIssuerCompanyList: [],
      recipientCompanyList: [],
      contractType: 0,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      invoiceContractTypeList: this.$Dictionaries.trade_invoice_contract_type,
      invoiceTypeList: this.$Dictionaries.trade_invoice_type,
      currentComponent: '',
      visibleFrom: false,
      invoiceIssuerCorporationFetching: false,
      recipientCorporationFetching: false,
      confirmLoadingFrom: false,
      projectFetching: false,
      selectedProjectId: undefined,
      mdl: {},
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      detailColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 100,
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'count',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '单价',
          dataIndex: 'unit_price',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 100,
          ellipsis: true,
          align: 'center',
          customRender: (text) => this.$Dictionaries.unit[text] || '无'
        },
        {
          title: '货币',
          dataIndex: 'currency',
          width: 100,
          align: 'center',
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.currency[text] || '无'
        },
        {
          title: '税率(%)',
          dataIndex: 'rate',
          width: 100,
          scopedSlots: { customRender: 'rate_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '税额',
          dataIndex: 'total_tax',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '含税金额',
          dataIndex: 'total_price',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
    // this.handleProjectSearch(undefined)
    // this.handleClientSearch(undefined)
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 16 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    moment,
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    contractTypeChange (values) {
      if (values !== undefined && values.length === 2) {
        this.contractType = values[0]
        this.contractList = []
        this.sellContractList = []
        if (values[0] === 100) {
          this.handleSellContractSearch(undefined)
        } else {
          this.handleContractSearch(values[1], undefined)
        }
      }
    },
    contractApiByType (type) {
      switch (type) {
        case 201:
          return storage_contract_list
        case 206:
          return freight_forwarding_contract_list
        case 203:
          return charter_party_contract_list
        case 204:
          return booking_contract_list
        case 205:
          return inspection_contract_list
        case 207:
          return loading_supervision_contract_list
        case 202:
          return insurance_contract_list
        case 208:
          return supervision_contract_list
        case 209:
          return guarantee_contract_list
        default:
          return contract_list
      }
    },
    handleContractSearch (type, value) {
      // this.otherData.ordinary_contract_type = type
      this.contractApiByType(type)({ project_id: this.selectedProjectId, page: 1, page_size: 999, number: value }).then((res) => {
        const result = res.data.entries || []
        this.contractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      })
    },
    handleSellContractSearch (value) {
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.sellContractList = []
        this.clientList = []
        this.form.setFieldsValue({ sell_contract_id: undefined })
        this.form.setFieldsValue({ client_id: undefined })
        this.handleSellContractSearch()
        this.handleClientSearch(undefined)
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.selectedProjectId }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleInvoiceIssuerCorporationSearch (value) {
      this.handleCorporation({ name: value }, 1)
    },
    handleRecipientCorporationSearch (value) {
      this.handleCorporation({ name: value }, 2)
    },
    handleCorporation (parameter, index) {
      if (index === 1) {
        this.invoiceIssuerCorporationFetching = true
      } else {
        this.recipientCorporationFetching = true
      }
      corporation_list(parameter).then((res) => {
        if (index === 1) {
          this.invoiceIssuerCompanyList = res.data.entries || []
        } else {
          this.recipientCompanyList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.invoiceIssuerCorporationFetching = false
        } else {
          this.recipientCorporationFetching = false
        }
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    handleAddDetail () {
      this.currentComponent = 'DetailCreateForm'
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'DetailCreateForm') {
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.detail.push(values)
          }
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.detail) {
        this.otherData.detail = this.otherData.detail.map(item => {
          item.key = undefined
          return item
        })
      }
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
